<template>
  <v-list-item v-if="team?.name && list" three-line>
    <v-list-item-content>
      <v-list-item-title>
        Vertriebsteam
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-content>
      <v-list-item-title>
        {{ team?.name }}
      </v-list-item-title>

      <v-list-item-subtitle v-if="team?.teamleiter">
        Teamleiter:
        {{ team?.teamleiter?.name }}
      </v-list-item-subtitle>

      <v-list-item-subtitle
        v-if="team?.teamleiter?.email"
      >
        E-Mail: {{ team?.teamleiter?.email }}
      </v-list-item-subtitle>

      <v-list-item-subtitle
        v-if="team?.teamleiter?.phone_number_1 && team?.teamleiter?.phone_number_1 != 'NULL'"
      >
        Tel.: {{ team?.teamleiter?.phone_number_1 }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
  <v-row v-else-if="team?.name && !list">
    <v-col cols="12">
      <v-divider />
    </v-col>
    <v-col cols="12" lg="4">
      <v-list-item-title>
        Vertriebsteam
      </v-list-item-title>
    </v-col>
    <v-col>
      <v-list-item class="pa-0">
        <v-list-item-content class="pa-0">
          <b>
            {{ team?.name }}
          </b>
          <v-list-item-subtitle v-if="team?.teamleiter">
            Teamleiter:
            {{ team?.teamleiter?.name }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            v-if="team?.teamleiter?.email"
          >
            E-Mail: {{ team?.teamleiter?.email }}
          </v-list-item-subtitle>

          <v-list-item-subtitle
            v-if="team?.teamleiter?.phone_number_1 && team?.teamleiter?.phone_number_1 != 'NULL'"
          >
            Tel.: {{ team?.teamleiter?.phone_number_1 }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
export default {
   props: {
      offerData: {
         type: Object,
         required: true,
      },
      list: {
         type: Boolean,
         required: false,
         default: false
      }
   },
   data () {
      return {
         team: {},
      }
   },
   mounted: function () {
      this.loadTeam()
   },
   methods: {
      loadTeam () {
         axios.get(
            this.route('offerData.vertriebsteam.info', { offerData: this.offerData.id })
         ).then(response => {
            if (response.data.team) {
               this.team = response.data.team
               console.log(this.team)
            }
         })
      }
   }
}
</script>

<style>
</style>
